import '@rainbow-me/rainbowkit/styles.css';
import { RainbowKitProvider, ConnectButton } from '@rainbow-me/rainbowkit';
import { WagmiConfig } from 'wagmi';
import { config, chains } from './config/wagmi';
import { 
  MintCard, 
  RecentMints, 
  HalvingSchedule, 
  Footer, 
  TokenInfo,
  MintingStats 
} from './components';
import './App.css';

function truncateAddress(address) {
  if (!address) return '';
  return `${address.slice(0, 6)}`;
}

function App() {
  return (
    <WagmiConfig config={config}>
      <RainbowKitProvider chains={chains}>
        <div className="App">
          <header className="header">
            <div className="header-content">
              <div className="header-left">
                <img src="/logo.png" alt="BitMemeCoin Logo" className="logo" />
                <div className="header-text">
                  <h1>BitMemeCoin</h1>
                  <p className="header-subtitle">Mint $BMC today!</p>
                </div>
              </div>
              <ConnectButton />
            </div>
          </header>

          <main className="main-content">
            <div className="content-wrapper">
              <div className="mint-section">
                <MintCard />
                <div className="mint-cta">
                  <h3>Start Minting BitMemeCoin Today!</h3>
                  <p>Join thousands of others who are already minting BMC. Every mint brings you closer to the next halving!</p>
                </div>
              </div>

              <div className="info-grid">
                <TokenInfo />
                <RecentMints />
              </div>

              <div className="how-it-works">
                <h2>How to Mint BMC</h2>
                <div className="instructions-section">
                  <div className="instructions-content">
                    <div className="steps-list">
                      <div className="step-item">
                        <div className="step-number">1</div>
                        <div className="step-text">Connect your wallet</div>
                      </div>
                      <div className="step-item">
                        <div className="step-number">2</div>
                        <div className="step-text">Wait for cooldown (2min global, 20min personal)</div>
                      </div>
                      <div className="step-item">
                        <div className="step-number">3</div>
                        <div className="step-text">Click "Mint BMC" when ready</div>
                      </div>
                      <div className="step-item">
                        <div className="step-number">4</div>
                        <div className="step-text">Confirm transaction in your wallet</div>
                      </div>
                    </div>
                    <img src="/logo.png" alt="" className="instructions-logo" />
                  </div>
                  
                  <div className="key-info">
                    <p>BitMemeCoin (BMC) follows Bitcoin's distribution model: Fair mint of 50 BMC per mint, halving every 210,000 mints, with a maximum supply of 21M BMC. Small AVAX fee for gas.</p>
                  </div>
                </div>
              </div>

              <HalvingSchedule />
            </div>
          </main>
          
          <Footer />
        </div>
      </RainbowKitProvider>
    </WagmiConfig>
  );
}

export default App;
